import { view } from '@yola/ws-sdk';
import { ALL_DEVICES_BREAKPOINT, DEVICE_BREAKPOINTS } from '../constants/visibility';
import { hasHiddenClassAt } from './is-hidden-at';
import { hideAt, hideOnAllDevices, unhideAt, unhideOnlyAt } from './hidden-class-tokens';

const getCurrentClass = (elementId) => view.accessors.getElementAttribute(elementId, 'class') || '';

const willBeHiddenOnAllDevices = (currentClass, breakpoint) =>
  DEVICE_BREAKPOINTS.every(
    (deviceBreakpoint) =>
      deviceBreakpoint === breakpoint || hasHiddenClassAt(currentClass, deviceBreakpoint)
  );

export const getNextClass = (currentClass, breakpoint) => {
  if (breakpoint === ALL_DEVICES_BREAKPOINT) {
    if (hasHiddenClassAt(currentClass, ALL_DEVICES_BREAKPOINT)) {
      return unhideAt(currentClass, breakpoint);
    }

    return hideOnAllDevices(currentClass);
  }

  if (hasHiddenClassAt(currentClass, ALL_DEVICES_BREAKPOINT)) {
    return unhideOnlyAt(currentClass, breakpoint);
  }

  if (hasHiddenClassAt(currentClass, breakpoint)) {
    return unhideAt(currentClass, breakpoint);
  }

  if (willBeHiddenOnAllDevices(currentClass, breakpoint)) {
    return hideOnAllDevices(currentClass);
  }

  return hideAt(currentClass, breakpoint);
};

const toggleBlockVisibilityAtBreakpoint = (elementId, breakpoint) => {
  const currentClass = getCurrentClass(elementId);
  const nextClass = getNextClass(currentClass, breakpoint);

  view.operations.setElementAttribute(elementId, 'class', nextClass);

  return nextClass;
};

export default toggleBlockVisibilityAtBreakpoint;
